import { render, staticRenderFns } from "./DeskCalc.vue?vue&type=template&id=5b072fb2&scoped=true&"
import script from "./DeskCalc.vue?vue&type=script&lang=js&"
export * from "./DeskCalc.vue?vue&type=script&lang=js&"
import style0 from "./DeskCalc.vue?vue&type=style&index=0&id=5b072fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b072fb2",
  null
  
)

export default component.exports